import { AuthState } from '@okta/okta-auth-js';

import { FuturesContracts } from '../../services/backend/FuturesContracts';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFuturesContracts: () => FuturesContracts<AuthState> = () => {
  return useBaseApiClient(FuturesContracts);
};
